import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import CommandPalette from "@/components/CommandPalette";

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [manualWideCollapsed, setManualWideCollapsed] = useState(false);
  const [isXl, setIsXl] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(min-width: 1280px)").matches;
  });
  const location = useLocation();
  const showExpanded = isXl && !manualWideCollapsed;

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia("(min-width: 1280px)");
    const onChange = () => setIsXl(mq.matches);
    onChange();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return (
    <div className="min-h-dvh bg-background" style={{ backgroundImage: "radial-gradient(ellipse 140% 55% at 50% -8%, rgba(20,135,163,0.12) 0%, transparent 62%)" }}>
      <div className="flex min-w-0">
        {/* Desktop sidebar */}
        <aside className={`hidden md:fixed md:inset-y-0 md:flex md:flex-col z-30 transition-[width] duration-200 ${showExpanded ? "md:w-64" : "md:w-20"}`}>
          <Sidebar
            onClose={() => setMobileOpen(false)}
            expanded={showExpanded}
            showToggle={isXl}
            onToggleExpand={() => setManualWideCollapsed((v) => !v)}
          />
        </aside>

        {/* Main */}
        <div className={`flex-1 min-w-0 transition-[padding] duration-200 ${showExpanded ? "md:pl-64" : "md:pl-20"}`}>
          <Header onMenuClick={() => setMobileOpen(true)} />

          {/* Mobile drawer */}
          {mobileOpen && (
            <div className="fixed inset-0 z-[260] md:hidden">
              <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setMobileOpen(false)} />
              <div className="absolute left-0 top-0 h-full w-[280px] shadow-2xl animate-in">
                <Sidebar onClose={() => setMobileOpen(false)} expanded />
              </div>
            </div>
          )}

          {/* Content */}
          <main className="relative z-10 min-w-0 p-0 overflow-x-hidden">
            <Outlet />
          </main>
          <CommandPalette />
        </div>
      </div>
    </div>
  );
}
